module.exports = __webpack_public_path__ + "img/branton-prepack-case.26710d74.jpg";